
// App specific colors
export default {
	heightReduce: 300,		// Modal view px reduction from window height
	defaultWidth: 300,		// Default modal width in px
	logoBoxAlpha: 0.53,		// Alpha level for logo box
	minModalHeight: 350,
	mapOverlaysLeftMargin: 20,
};
